import { useState } from "react";
import { useAuthStore } from "@/stores/auth";
import type { WorkspaceProps } from "./model";
/** Drafts belong to one event, object and account, even when React reuses a view. */
export function useRoundDraft<T>(props: WorkspaceProps, objectId: string, initial: T) {
  const account = useAuthStore((state) => state.user?.id);
  const key = JSON.stringify([props.competitionId, props.principalKey, objectId, account]);
  const [stored, setStored] = useState<{ key: string; value: T }>({ key, value: initial });
  const value = stored.key === key ? stored.value : initial;
  const set = (next: T | ((previous: T) => T)) =>
    setStored((previous) => ({
      key,
      value:
        typeof next === "function"
          ? (next as (previous: T) => T)(previous.key === key ? previous.value : initial)
          : next,
    }));
  return [value, set] as const;
}
